module.exports = __webpack_public_path__ + "static/media/error-img2.71e996ff.png";